var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 15.3499C13.5724 15.3499 14.8484 14.0739 14.8484 12.4999C14.8484 10.9259 13.5724 9.6499 11.9984 9.6499C10.4244 9.6499 9.14844 10.9259 9.14844 12.4999C9.14844 14.0739 10.4244 15.3499 11.9984 15.3499Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.9984 15.3499C13.5724 15.3499 14.8484 14.0739 14.8484 12.4999C14.8484 10.9259 13.5724 9.6499 11.9984 9.6499C10.4244 9.6499 9.14844 10.9259 9.14844 12.4999C9.14844 14.0739 10.4244 15.3499 11.9984 15.3499Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 3.93994C7.27 3.93994 2 8.55994 2 12.4999C2 16.2599 7.27 21.0599 12 21.0599C17 21.0599 22 16.4699 22 12.4999C22 8.67994 16.73 3.93994 12 3.93994ZM12 16.8499C11.1397 16.8499 10.2986 16.5948 9.58327 16.1168C8.86792 15.6389 8.31037 14.9595 7.98112 14.1646C7.65188 13.3698 7.56574 12.4951 7.73358 11.6513C7.90143 10.8075 8.31573 10.0324 8.92409 9.42403C9.53244 8.81567 10.3075 8.40137 11.1514 8.23353C11.9952 8.06568 12.8698 8.15182 13.6647 8.48107C14.4595 8.81031 15.1389 9.36786 15.6169 10.0832C16.0949 10.7986 16.35 11.6396 16.35 12.4999C16.35 13.6536 15.8917 14.7601 15.0759 15.5759C14.2601 16.3916 13.1537 16.8499 12 16.8499Z",
    fill: "#1A1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.60994389f850adb8b2774ca7b9fb219f.svg";
export { ForwardRef as ReactComponent };